import React, { Component } from "react";

import {
  CButton,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CInputCheckbox,
  CInputGroup,
  CLabel
} from "@coreui/react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class DisciplinesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // loading: false,
      // activities: [],
      // docs: [],
      selected: []
    };

    this.selectRowProp = {
      mode: "checkbox",
      bgColor: "#3399ff22", // you should give a bgcolor, otherwise, you can't regonize which row has been selected
      hideSelectColumn: true, // enable hide selection column.
      clickToSelect: true // you should enable clickToSelect, otherwise, you can't select column.
    };

    this.options = {
      onRowClick: row => this.onRowClick(row)
    };

    this.tableRef = React.createRef();
  }

  onRowClick(row) {
    if (this.state.selected.includes(row.id)) {
      this.setState(state => {
        let prev = [...state.selected];
        prev.splice(prev.indexOf(row.id), 1);

        return { selected: prev };
      });
    } else {
      this.setState(state => {
        let prev = [...state.selected];
        prev.push(row.id);

        return { selected: prev };
      });
    }
  }

  selectAll() {
    if (this.state.selected.length === this.props.disciplines.length) {
      this.tableRef.current.state.selectedRowKeys = [];
      this.setState({ selected: [] });
    } else {
      this.tableRef.current.state.selectedRowKeys = this.props.disciplines.map(
        discipline => discipline.id
      );
      this.setState({
        selected: this.props.disciplines.map(discipline => discipline.id)
      });
    }
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  render() {
    return (
      <CModal
        size="lg"
        show
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle className="d-inline-block mr-1">
            Selecione as disciplinas do membro
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          className="p-0"
          style={{ maxHeight: "600px", overflow: "auto" }}
        >
          {this.props.disciplines && this.props.disciplines.length > 0 ? (
            <BootstrapTable
              ref={this.tableRef}
              data={this.props.disciplines}
              selectRow={this.selectRowProp}
              options={this.options}
              tableStyle={{ border: 0 }}
              trClassName="cursor"
              hover
              version="4"
            >
              <TableHeaderColumn
                isKey
                className="d-none"
                tdStyle={{ width: "1rem", border: 0, padding: "1.25rem" }}
                dataField="id"
                dataFormat={() => <i className="fa fa-book text-danger"></i>}
              >
                Id
              </TableHeaderColumn>
              <TableHeaderColumn
                className="d-none"
                tdStyle={{ border: 0, padding: "1.25rem" }}
                dataField="discipline_name"
              >
                Disciplina
              </TableHeaderColumn>
              <TableHeaderColumn
                className="d-none"
                tdStyle={{ border: 0, padding: "1.25rem" }}
                dataField="serie_name"
              >
                Série
              </TableHeaderColumn>
            </BootstrapTable>
          ) : (
            <div className="d-flex p-3 justify-content-center">
              <span className="text-center text-muted">
                Nenhuma disciplina encontrada
              </span>
            </div>
          )}
        </CModalBody>
        <CModalFooter className="justify-content-between">
          <CInputGroup className="w-auto ml-4">
            <CInputCheckbox
              checked={
                this.state.selected.length === this.props.disciplines.length
              }
              onChange={() => this.selectAll()}
            />
            <CLabel className="m-0">Selecionar tudo</CLabel>
          </CInputGroup>
          <div>
            <CButton
              color="primary"
              disabled={this.state.selected === null}
              onClick={() => this.props.onClose(this.state.selected)}
            >
              Confirmar
            </CButton>{" "}
            <CButton color="secondary" onClick={() => this.props.onClose()}>
              Cancelar
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DisciplinesModal);
